<!--
 * @FileDescription: 账期管理-mobile
 * @Author: 陈文景
 * @Date: 2022-12-29 14:10:33
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>

</style>
